import React from 'react';
import { Table } from 'rsuite';
import TableSkeleton from '@/common/view/TableSkeleton';
import { WishlistProduct } from '../../main/model/CustomerTypes';
import { toDateText } from '@/common/util/formatUtil';

const { Column, HeaderCell, Cell } = Table;

interface CustomerWishlistProductTableProps {
  data?: WishlistProduct[];
  isLoading?: boolean;
}

const DateCell = ({ rowData, dataKey, ...props }: any) => {
  const dateValue = rowData[dataKey];
  if (!dateValue) {
    return <Cell {...props}>-</Cell>;
  }
  try {
    return <Cell {...props}>{toDateText(new Date(dateValue), 'yyyy-MM-dd')}</Cell>;
  } catch {
    return <Cell {...props}>-</Cell>;
  }
};

const PriceCell = ({ rowData, dataKey, ...props }: any) => {
  const value = rowData[dataKey];
  const formatted = new Intl.NumberFormat('ko-KR').format(value);
  return (
    <Cell {...props} style={{ paddingRight: '20px' }}>
      {formatted}원
    </Cell>
  );
};

export const CustomerWishlistProductTable: React.FC<CustomerWishlistProductTableProps> = ({
  data,
  isLoading = false,
}) => {
  if (isLoading) {
    return <TableSkeleton columns={3} rows={5} columnWidths={[1, 2, 1]} />;
  }

  return (
    <Table
      height={272}
      data={data || []}
      rowClassName="!cursor-default"
      locale={{
        loading: '로딩 중...',
        emptyMessage: '찜 상품이 없습니다.',
      }}>
      <Column width={140} align="center">
        <HeaderCell>추가 일자</HeaderCell>
        <DateCell dataKey="created_at" />
      </Column>
      <Column flexGrow={1} align="center">
        <HeaderCell>상품명</HeaderCell>
        <Cell dataKey="product_name" />
      </Column>
      <Column width={150}>
        <HeaderCell align="center">가격</HeaderCell>
        <PriceCell align="right" dataKey="product_price" />
      </Column>
    </Table>
  );
};
